import { render, staticRenderFns } from "./BusDataSyncUopDocMainSetList.vue?vue&type=template&id=10c6f5aa&scoped=true&"
import script from "./BusDataSyncUopDocMainSetList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncUopDocMainSetList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncUopDocMainSetList.vue?vue&type=style&index=0&id=10c6f5aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6f5aa",
  null
  
)

export default component.exports